:host {
  width: 100%;
  display: block;
  text-align: center;
  padding-top: calc(var(--spacer) * 4);

  #success-title {
    color: var(--body-text-arrows-400);
  }

  ul {
    text-align: left;
    width: 200px;
    margin: 0 auto;

    &.dashed {
      list-style-type: none;

      li {
        text-indent: -5px;
      }

      li:before {
        content: '-';
        text-indent: -5px;
      }
    }
  }
}
